import { paymentConstants } from "../actions/constants/paymentConstants";

export interface PaymentState {
  loading: boolean;
  error: string | null;
  lastActionSuccess: boolean;
  lastAction: string | null;
}

const initialState: PaymentState = {
  loading: false,
  error: null,
  lastActionSuccess: false,
  lastAction: null,
};

const paymentReducer = (state = initialState, action: any): PaymentState => {
  switch (action.type) {
    case paymentConstants.getFinanceRequest:
      return {
        ...state,
        loading: true,
        error: null,
        // Don't reset lastActionSuccess/lastAction here to allow useEffect to process them
      };
    case paymentConstants.getFinanceSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        // Preserve lastActionSuccess/lastAction from previous action (create/update)
      };
    case paymentConstants.getFinanceFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
        // Preserve lastActionSuccess/lastAction from previous action
      };

    case paymentConstants.createPaymentRequest:
      return {
        ...state,
        loading: true,
        error: null,
        lastActionSuccess: false,
        lastAction: null,
      };
    case paymentConstants.createPaymentSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        lastActionSuccess: true,
        lastAction: 'createPayment',
      };
    case paymentConstants.createPaymentFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastActionSuccess: false,
        lastAction: 'createPayment',
      };

    case paymentConstants.updatePaymentRequest:
      return {
        ...state,
        loading: true,
        error: null,
        lastActionSuccess: false,
        lastAction: null,
      };
    case paymentConstants.updatePaymentSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        lastActionSuccess: true,
        lastAction: 'updatePayment',
      };
    case paymentConstants.updatePaymentFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastActionSuccess: false,
        lastAction: 'updatePayment',
      };

    case paymentConstants.deletePaymentRequest:
      return {
        ...state,
        loading: true,
        error: null,
        lastActionSuccess: false,
        lastAction: null,
      };
    case paymentConstants.deletePaymentSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        lastActionSuccess: true,
        lastAction: 'deletePayment',
      };
    case paymentConstants.deletePaymentFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastActionSuccess: false,
        lastAction: 'deletePayment',
      };

    case paymentConstants.createAlertRequest:
      return {
        ...state,
        loading: true,
        error: null,
        lastActionSuccess: false,
        lastAction: null,
      };
    case paymentConstants.createAlertSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        lastActionSuccess: true,
        lastAction: 'createAlert',
      };
    case paymentConstants.createAlertFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastActionSuccess: false,
        lastAction: 'createAlert',
      };

    case paymentConstants.updateAlertRequest:
      return {
        ...state,
        loading: true,
        error: null,
        lastActionSuccess: false,
        lastAction: null,
      };
    case paymentConstants.updateAlertSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        lastActionSuccess: true,
        lastAction: 'updateAlert',
      };
    case paymentConstants.updateAlertFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastActionSuccess: false,
        lastAction: 'updateAlert',
      };

    case paymentConstants.deleteAlertRequest:
      return {
        ...state,
        loading: true,
        error: null,
        lastActionSuccess: false,
        lastAction: null,
      };
    case paymentConstants.deleteAlertSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        lastActionSuccess: true,
        lastAction: 'deleteAlert',
      };
    case paymentConstants.deleteAlertFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastActionSuccess: false,
        lastAction: 'deleteAlert',
      };

    case paymentConstants.clearPaymentState:
      return initialState;

    default:
      return state;
  }
};

export default paymentReducer;
